import { nsSelector } from '../../../../../utils/redux';

const generalInfo = nsSelector('generalInfo');

export const info = generalInfo('info');
